//libraries
import Vue from 'vue'
let resource = 'pickup_location'
let resource_name = 'punto de entrega'
let resource_name_plural = 'puntos de entrega'

let state = {

}

state[resource + 's'] = []

//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async all({ commit }, params) {
    try {
      let res = await Vue.request.get(
        `account/${params.account_id}/${resource}s`,
        { params: params.params || {} }
      );
      let resData;
      if (res.data.success) {
        commit(
          "setItems",
          res.data.resource.map((l) => {
            l.error = false;
            return l;
          })
        );
        resData = res.data;
      } else resData = { error: `Error obteniendo ${resource_name_plural}.` };
      if (params.callback) params.callback(resData);
    } catch (e) {
      if (params.callback)
        params.callback({
          error: `Ocurrió un error obteniendo ${resource_name_plural}.`,
        });
      console.error(e);
    }
  },
  async get({ commit }, params) {
    try {
      let res = await Vue.request.get(
        `${resource}/${params[resource + "_id"]}`,
        { params: params.params || {} }
      );
      if (res.data.success && params.callback) {
        params.callback(res.data);
      } else if (params.callback) {
        params.callback({ error: `Error obteniendo ${resource_name}.` });
      }
    } catch (e) {
      if (params.callback)
        params.callback({
          error: `Ocurrió un error obteniendo ${resource_name}.`,
        });
      console.error(e);
    }
  },
  async getSchedule({ commit }, params) {
    try {
      let res = await Vue.request.get(
        `${resource}/${params[resource + "_id"]}/schedule`,
        { params: params.params || {} }
      );
      if (res.data.success && params.callback) {
        params.callback(res.data);
      } else if (params.callback) {
        params.callback({ error: `Error obteniendo ${resource_name}.` });
      }
    } catch (e) {
      if (params.callback)
        params.callback({
          error: `Ocurrió un error obteniendo ${resource_name}.`,
        });
      console.error(e);
    }
  },
  async create({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}`, params);
      console.log(res.data);
      if (res.data.success && params.callback) {
        params.callback(res.data);
      } else if (params.callback) {
        params.callback({ error: `Error creando ${resource_name}.` });
      }
    } catch (e) {
      if (params.callback)
        params.callback({
          error: `Ocurrió un error creando ${resource_name}.`,
        });
      console.error(e);
    }
  },
  async update({ commit }, params) {
    try {
      let res = await Vue.request.patch(
        `${resource}/${params[resource + "_id"]}`,
        params
      );
      if (res.data.success && params.callback) {
        params.callback(res.data);
      } else if (params.callback) {
        params.callback({ error: `Error actualizando ${resource_name}.` });
      }
    } catch (e) {
      if (params.callback)
        params.callback({
          error: `Ocurrió un error actualizando ${resource_name}.`,
        });
      console.error(e);
    }
  },
  async updateSchedule({ commit }, params) {
    try {
      let res = await Vue.request.patch(
        `${resource}/${params[resource + "_id"]}/schedule`,
        params
      );
      if (res.data.success && params.callback) {
        params.callback(res.data);
      } else if (params.callback) {
        params.callback({ error: `Error actualizando ${resource_name}.` });
      }
    } catch (e) {
      if (params.callback)
        params.callback({
          error: `Ocurrió un error actualizando ${resource_name}.`,
        });
      console.error(e);
    }
  },
  async destroy({ commit }, params) {
    try {
      let res = await Vue.request.delete(
        `${resource}/${params[resource + "_id"]}`,
        { data: params }
      );
      if (res.data.success && params.callback) {
        params.callback(res.data);
      } else if (params.callback) {
        params.callback({ error: `Error eliminando ${resource_name}.` });
      }
    } catch (e) {
      if (params.callback)
        params.callback({
          error: `Ocurrió un error eliminando ${resource_name}.`,
        });
      console.error(e);
    }
  },
  async createPolygon(
    { commit },
    { polygon, pickup_location_id, account_id, callback }
  ) {
    try {
      const res = await Vue.request.post(`/account/${account_id}/geometries`, {
        color: polygon.color,
        points: polygon.formatePath(),
        type: "polygon",
        pickup_location_id,
      });
      if (res.data.success && callback) {
        callback(res.data);
      } else if (callback) throw new Error(res.data.result);
    } catch (e) {
      console.error(e);
      if (callback)
        callback({ error: `Ocurrió un error  creando el polígono.` });
    }
  },
  async deletePolygon({ commit }, { callback, geometryId }) {
    try {
      const res = await Vue.request.delete(`/geometry/${geometryId}`);
      if (res.data.success && callback) return callback(res.data);
      throw new Error(res.data.result);
    } catch (e) {
      console.error(e);
      if (callback)
        callback({ error: `Ocurrió un error eliminando el polígono.` });
    }
  },
  async products({ commit }, { params, callback, account_id }) {
    try {
      const res = await Vue.request.get(`/account/${account_id}/products`, {
        params
      });
      if (!res.data.success) throw new Error(res.data.result);
      callback(res.data);
    } catch (error) {
      console.error(error);
      if (callback)
        callback({ error: `Ocurrió un error obteniendo los productos.` });
    }
  },
  async toggleProduct({ commit }, { enabled, stockId, callback }) {
    try {
      const res = await Vue.request.patch(`/product_stock/${stockId}`, {
        enabled,
      });
      if (!res.data.success) throw new Error(res.data.error);
      callback(res.data.resource);
    } catch (error) {
      console.error(error);
      if (callback)
        callback({
          error: `Ocurrió un error cambiando el estado del producto.`,
        });
    }
  },
  async editManyProducts({ commit }, { params={}, callback=()=>{} }) {
    try {
      const res = await Vue.request.patch('/product_stock/edit', params);
      if (!res.data.success) throw new Error(res.data.error);
      callback(res.data);
    } catch (error) {
      console.error(error);
      callback({ error: `Ocurrió un error editando los productos.` });
    }
  },
  async editManyLocations({ commit }, { params={}, callback=()=>{} }) {
    try {
      const res = await Vue.request.patch(`${resource}/edit`, params);
      if (!res.data.success) throw new Error(res.data.error);
      callback(res.data);
    } catch (error) {
      console.error(error);
      callback({ error: `Ocurrió un error editando los productos.` });
    }
  }
};

//functions receive state
let mutations = {
  setItems (state, items) {
    state[resource + 's'] = items
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
